export default __webpack_public_path__ + "static/media/icon-gamepad.fb5cc0ec.svg";